import apiBase from "../../api/axios";

export const iniciarAplicacionService = async () => {
  const response = await apiBase.post("v1/aplicacion-talentos/iniciar/");
  return response.data;
};

export const getActividadActualService = async () => {
  const response = await apiBase.get(
    "v1/aplicacion-talentos/actividad-actual/",
  );
  return response.data;
};

export const guardarRespuestasService = async (payload) => {
  const response = await apiBase.post(
    "v1/aplicacion-talentos/guardar-respuestas/",
    payload,
  );
  return response.data;
};

export const getEstadoAplicacionService = async () => {
  const response = await apiBase.get("v1/aplicacion-talentos/estado/");
  return response.data;
};

export const getResumenAplicacionService = async () => {
  const response = await apiBase.get("v1/aplicacion-talentos/resumen/");
  return response.data;
};
